<template>
  <div class="overflow-auto overflow-x-hidden pr-1">
    <div class="row">
      <div class="col-12 col-xl-6 mb-4">
        <div>
          <BaseTable
            :items="dashboard.tickets"
            header="tickets"
            :row-click="openTicket"
          />
        </div>
      </div>
      <div class="col-12 col-xl-6 mb-4">
        <div
          v-if="isLoaded"
          class="d-flex flex-column justify-content-center"
        >
          <h6 class="text-left table-header">
            {{ 'Tickets by status' | i18n }}
          </h6>
          <div style="height: 500px; width: 500px; overflow: hidden">
            <PieChart
              :data="chartData"
              :options="chartOptions"
              :height="500"
              :width="500"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

import { DashboardMixin, NotificationMixin, ApiMixin } from '../../../../mixins';
import PieChart from '../Charts/pie-chart.vue';
import { TICKET_STATUSES } from '../../../../../../../constants';
import api from '../../../api';
import BaseTable from './base-table';

export default {
  name: 'TicketsDashboard',
  components: { BaseTable, PieChart },
  mixins: [DashboardMixin, NotificationMixin, ApiMixin],
  data: function () {
    return {
      baseURL: axios.defaults.baseURL,
      statuses: TICKET_STATUSES,
      dashboard: {
        tickets: [],
      },
      isLoaded: false,
      chartOptions: {
        hoverBorderWidth: 3,
      },
      chartData: {
        hoverBorderWidth: 10,
        labels: [this.$translate('New Tickets'), this.$translate('In progress Tickets'), this.$translate('Finished Tickets')],
        datasets: [
          {
            label: 'Tickets',
            backgroundColor: ['#17a2b8', '#28a745', '#6c757d'],
            data: [0, 0, 0],
          },
        ],
      },
    };
  },
  created() {
    this.loadDashboard();
  },
  methods: {
    openTicket(c) {
      this.$router.push({ name: 'ticket-details', params: { id: c.id } });
    },
    async loadDashboard() {
      try {
        this.isLoaded = false;
        const formateData = ({ data }) => {
          return data.map((item) => {
            item.title = item.title || '';
            item.template = item.template ? item.template.name : '';
            item.teamName = item.team ? item.team.name : '';
            item.userName = item.user ? item.user.username : '';
            item.updatedAt = moment(item.updatedAt).format('DD.MM.YY HH:mm');
            let color = 'secondary';
            if (item.status === this.statuses.NEW) color = 'info';
            if (item.status === this.statuses.IN_PROGRESS) color = 'success';
            if (item.status === this.statuses.FINISHED) color = 'secondary';
            item.statusColor = color;
            item.status = this.$translate(item.status);
            return item;
          });
        };
        const ticketsResponse = await api.ticket.get({
          page: 1,
          limit: 10,
          sortBy: 'createdAt',
          sortOrder: 'desc',
        });
        this.dashboard = { tickets: formateData(ticketsResponse) };
        const ticketsCountResponse = await api.ticket.getCountByStatus();
        const { data: { newStatusCount, inProgressStatusCount, finishedStatusCount } } = ticketsCountResponse;
        this.chartData.datasets[0].data = [newStatusCount, inProgressStatusCount, finishedStatusCount];
        this.isLoaded = true;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.label,
.description {
  color: #7586a5;
}

.error {
  color: red;
}

.section-header {
  margin: 0;
}

h5 {
  margin-bottom: 20px;
}

button {
  width: 170px;
}

@media (max-width: 768px) {
  button {
    margin-top: 20px;
  }
}

@media (min-width: 768px) {
  button {
    float: right;
  }
}

.main-content {
  height: 100%;
  max-height: 100%;
  min-height: fit-content;
}

.today-container {
  border-bottom: 1px solid lightgrey;
  padding-bottom: 5px;
}

.yesterday-container {
  border-right: 1px solid lightgrey;
}

p {
  margin-bottom: 0.5rem;
}

.grey-text {
  color: #7586a5;
}

.card-bottom {
  position: absolute;
  bottom: 20px;
  right: 30px;
}

.card-container {
  background: #ffffff;
  padding: 15px;
  height: 100%;
  min-height: 130px;
  font-size: 0.9rem;
}

.img-preview {
  height: 58px;
}

.img-box {
  display: flex;
  justify-content: center;
  width: 100%;
  top: 11px;
  left: 0;
}

.overflow-x-hidden {
  overflow-x: hidden!important;
}
</style>
